import { render, staticRenderFns } from "./createImg.vue?vue&type=template&id=187d018c&scoped=true&"
import script from "./createImg.vue?vue&type=script&lang=js&"
export * from "./createImg.vue?vue&type=script&lang=js&"
import style0 from "./createImg.vue?vue&type=style&index=0&id=187d018c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187d018c",
  null
  
)

export default component.exports